import { render, staticRenderFns } from "./NotificationCenterMain.vue?vue&type=template&id=2cd65ab0&scoped=true&"
import script from "./NotificationCenterMain.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterMain.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterMain.vue?vue&type=style&index=0&id=2cd65ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd65ab0",
  null
  
)

export default component.exports